import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f396f00&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f396f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f396f00')) {
      api.createRecord('1f396f00', component.options)
    } else {
      api.reload('1f396f00', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f396f00&scoped=true", function () {
      api.rerender('1f396f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectInfo/index.vue"
export default component.exports